
define('template!adminColorSelectionsListToolbarView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="cs-toolbar-search">\n  <input type="search" class="js-search" placeholder="' +
((__t = ( _.escape(labels.search) )) == null ? '' : __t) +
'" value="' +
((__t = ( _.escape(search) )) == null ? '' : __t) +
'"/>\n</div>\n<div class="cs-toolbar-actions">\n  <button type="button" class="cs-btn js-libraries" title="' +
((__t = ( _.escape(labels.librariesTitle) )) == null ? '' : __t) +
'">\n    <i class="fa fa-book"></i> ' +
((__t = ( _.escape(labels.libraries) )) == null ? '' : __t) +
'\n  </button>\n  <button type="button" class="cs-btn js-export" title="' +
((__t = ( _.escape(labels.exportTitle) )) == null ? '' : __t) +
'">\n    <i class="fa fa-download"></i> ' +
((__t = ( _.escape(labels.export) )) == null ? '' : __t) +
'\n  </button>\n  <label class="cs-btn cs-import" title="' +
((__t = ( _.escape(labels.importTitle) )) == null ? '' : __t) +
'">\n    <i class="fa fa-upload"></i> <span class="js-import-label">' +
((__t = ( _.escape(labels.import) )) == null ? '' : __t) +
'</span>\n    <input type="file" class="js-import" accept=".xlsx,.xls,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"/>\n  </label>\n  <button type="button" class="cs-btn cs-btn-primary js-create"><i class="fa fa-plus"></i> ' +
((__t = ( _.escape(labels.create) )) == null ? '' : __t) +
'</button>\n</div>\n<div class="cs-import-result js-import-result" style="display: none;"></div>\n';

}
return __p
};});

